import React, { useState } from 'react';
import { connect } from 'react-redux';

import TextField from '@mui/material/TextField';
import Grid from '@mui/material/Grid';

import PhoneInput from '../shared/PhoneInput';
import Button from '../shared/Button';
import Alert from '../shared/Alert';
import Modal from './Modal';

import { withFirebase } from '../../firebase';

import '../dashboard/dashboard.scss';

const Enable2FAModal = (props) => {
  const {
    open,
    onClose,
    phone,
    firebase,
    onSuccess,
    multiFactorEnabled,
  } = props;

  const [phoneNumber, setPhoneNumber] = useState(phone || '');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const onSubmit = async () => {
    setLoading(true);
    try {
      if (!!phoneNumber && !!password) {
        if (!!multiFactorEnabled) {
          await firebase.disable2FA(password);
        }

        const formatted = !phoneNumber?.includes('+') ? `+${phoneNumber}` : phoneNumber;
        await firebase.enable2FA(formatted, password);
        onSuccess();
        onClose();
      }
    } catch (err) {
      setError('Something went wrong. Please contact administrator.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      open={open}
      onClose={() => {
        onClose();
        setPhoneNumber('');
        setPassword('');
      }}
      onSubmit={onSubmit}
      title="Enable 2FA"
    >
      <div className="p-lg">
        <div className='secondary m-b-md'>You have to re-enter your current password and provide a valid phone number to enable multi-factor authentication</div>
        <Grid container spacing={0}>
          <Grid size={{ xs: 12, md: 12 }}>
            <div className="p-t-md">
              <PhoneInput
                value={phoneNumber}
                onChange={setPhoneNumber}
              />
            </div>
          </Grid>
        </Grid>
        <Grid container spacing={0}>
          <Grid size={{ xs: 12, md: 12 }}>
            <div className="p-t-md">
              <TextField
                id="password"
                type="password"
                label="Current password"
                value={password}
                onChange={(e) => {
                  setPassword(e.target.value);
                }}
                fullWidth
              />
            </div>
          </Grid>
        </Grid>
        <div className="actions m-t-lg d-flex flex-end">
          <Button
            text="Submit"
            color="primary"
            onClick={onSubmit}
            disabled={loading}
            loading={loading}
          />
        </div>
      </div>

      <Alert variant="error" message={error} open={!!error} onClose={() => setError(null)} />
    </Modal>
  );
};

const mapStateToProps = (state) => {
  return {
    phone: state.user?.currentUser?.phone,
    multiFactorEnabled: state.user?.currentUser?.multiFactorEnabled,
  };
};

export default connect(mapStateToProps)(withFirebase(Enable2FAModal));
